import { resolveTargetEnv, TargetEnv } from '@zealth/core/env/targetEnv'

export const getTargetEnv = (): TargetEnv =>
  resolveTargetEnv(
    import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
    import.meta.env.VITE_FIREBASE_USE_EMULATORS === 'true'
  )
